import {overwrite, getData} from 'country-list';
import {normalizeArrayObjects} from 'components/forms/fields/optionsHelper';

/**
 * Provides pretty country options for Select fields
 * This currently outputs [
 *   {
 *     value: '{country code}', // Alpha-2, ISO 3166
 *     label: `{emoji flag} {Country Name}`
 *   }
 * ]
 */

overwrite([
    {
        code: 'TW',
        name: 'Taiwan',
    },
]);

const countryFlag = isoCode => {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
              .toUpperCase()
              .replace(/./g, char =>
                  String.fromCodePoint(char.charCodeAt(0) + 127397)
              )
        : isoCode;
};

const countries = normalizeArrayObjects(
    getData(),
    'code',
    'name',
    null,
    (value, label) => `${countryFlag(value)} ${label}`
);

function useCountries() {
    return countries;
}

export default useCountries;
export {countries};
